module.exports = __webpack_public_path__ + "img/highRoller.0beb4949.png";